<template>
  <div class="amendments-container" style="max-width:100%;">
    <h1 style="margin-left: 20px;">{{ $t("evaluations") }}</h1>
    <div style="display:flex">
      <div class="support-con2">
        <div class="con1">
          <h3
            @click="
              showOrganizationsTable = true;
              showFlashcard = false;
              showStaticIdCardList = false;
              participantsKey++;
            "
          >
            {{ $t("list-of-participants") }}
          </h3>
          <h3
            @click="
              showStaticIdCardList = true;
              showOrganizationsTable = false;
              showFlashcard = false;
            "
          >
            {{ $t("list-of-id-cards") }}
          </h3>
          <!-- <h3>{{ $t("list-of-organizations") }}</h3>
          <h3>{{ $t("list-of-users") }}</h3> -->
          <h3
            @click="
              showFlashcard = true;
              showOrganizationsTable = false;
              showStaticIdCardList = false;
            "
          >
            {{ $t("flashcard") }}
          </h3>
        </div>

        <!-- Teilnehmerliste -->
        <div
          v-if="showOrganizationsTable"
          :key="participantsKey"
          style="display: flex; flex-direction: column;"
        >
          <div class="mt-2" style="text-align: left;margin-left: 30px;">
            <h6 class="p-2" style="color:grey; font-size: 0.9rem;">
              {{ $t("select-persons-for-pdf") }}
            </h6>
          </div>
          <div style="display: flex;">
            <div>
              <div class="mt-4" style="margin-right: 100px; margin-left: 40px;">
                <vs-input
                  class="search-input org-width"
                  icon-after="search"
                  :placeholder="$t('organization-search')"
                  v-model="oranization_search"
                  icon="search"
                  icon-no-border
                  label-placeholder="icon-no-border"
                />
                <div class="outer-con3">
                  <div class="table-container2">
                    <table>
                      <thead>
                        <tr>
                          <th @click="sort('name')">
                            {{ $t("organization") }}
                            <div
                              class="arrow"
                              v-if="'name' == currentSort"
                              v-bind:class="
                                ascending ? 'arrow_up' : 'arrow_down'
                              "
                            ></div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="cursor"
                          v-for="organization in organizations"
                          :key="organization.id"
                          @click="selectOrganization(organization)"
                        >
                          <td
                            :class="{
                              active: isActiveOrganization(organization.id),
                            }"
                          >
                            {{ organization.name }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!-- ID-Cards vorhanden -->
            <div
              v-if="selectedOrganization != null"
              class="table-container2"
              style="padding-left: 100px; margin-top: 6px; border-left:1px solid #CCCCCC;"
            >
              <vs-input
                class="search-input2"
                style="padding-bottom: 2px;"
                icon-after="search"
                :placeholder="$t('name-search')"
                v-model="person_search"
                icon="search"
                icon-no-border
                label-placeholder="icon-no-border"
              />
              <div class="outer-con3">
                <table v-if="selectedOrganization != null">
                  <thead>
                    <tr>
                      <th>
                        <input
                          style="margin-left: 5px;"
                          type="checkbox"
                          v-model="selectAll"
                          @change="selectAllItems"
                        />
                      </th>
                      <th @click="sortA('person_last_name')">
                        {{ $t("Name") }}
                        <div
                          class="arrow"
                          v-if="'person_last_name' == currentSortA"
                          v-bind:class="ascendingA ? 'arrow_up' : 'arrow_down'"
                        ></div>
                      </th>
                      <th @click="sortA('person_first_name')">
                        {{ $t("Vorname") }}
                        <div
                          class="arrow"
                          v-if="'person_first_name' == currentSortA"
                          v-bind:class="ascendingA ? 'arrow_up' : 'arrow_down'"
                        ></div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="cursor"
                      v-for="idCard in idCardsByOrganization"
                      :key="idCard.id"
                    >
                      <td>
                        <input
                          type="checkbox"
                          :checked="isInSelectedIdCards(idCard)"
                          v-model="idCard.selected"
                          @click="addIdCard(idCard)"
                        />
                      </td>
                      <td>{{ idCard.person_last_name }}</td>
                      <td>{{ idCard.person_first_name }}</td>
                    </tr>
                    <tr v-if="idCardsByOrganization.length === 0">
                      <td colspan="3">
                        {{ "Keine Ausweise vorhanden" }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-else>
                  Keine Organisation ausgewählt
                </div>
              </div>

              <div
                style="display: flex; justify-content: flex-end; margin-top: 5px;"
              >
                <div
                  v-if="
                    selectedOrganization &&
                      (selectedPersons.length > 0 || selectAll)
                  "
                  style="margin-left: 5px;margin-top: 40px;"
                >
                  <div style="position: relative;">
                    <label
                      for="selectedDate"
                      style="position: absolute; top: -17px; left: 3px; font-size: 12px; color: #999999;"
                    >
                      {{ $t("valid-until") + "*" }}
                    </label>
                    <vs-input
                      id="selectedDate"
                      type="date"
                      class="inputx spec-input"
                      v-model="selectedDate"
                    />
                  </div>
                </div>
                <div
                  v-if="
                    selectedOrganization &&
                      (selectedPersons.length > 0 || selectAll)
                  "
                  style="
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin-top: 25px;
                    margin-left: 50px;
                  "
                >
                  <span>Extrafelder anzeigen </span
                  ><vs-switch v-model="includeExtraField"></vs-switch>
                </div>
                <div
                  v-if="
                    selectedOrganization &&
                      (selectedPersons.length > 0 || selectAll)
                  "
                  style="margin-left: 50px; margin-top: 40px;"
                >
                  <vs-button
                    @click="generatePDF()"
                    class="generate-pdf-button"
                    icon="download"
                  >
                    {{ $t("generate-pdf") }}
                  </vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Flashcard-Komponente -->
        <div v-if="showFlashcard">
          <Flashcard />
        </div>
        <!--STATICIDCARD Komponente-->
        <div v-if="showStaticIdCardList">
          <StaticIdCardList />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import PopupIDcard from "../components/id-card/PopupIDcard.vue";
import PopupImportData from "../components/id-card/PopupImportData.vue";
import Flashcard from "./lists/Flashcard.vue";
import StaticIdCardList from "./lists/StaticIdCardList.vue";

export default Vue.extend({
  name: "Evaluations",
  components: {
    PopupIDcard,
    PopupImportData,
    Flashcard,
    StaticIdCardList,
  },
  async mounted() {
    await this.$store.dispatch("organization/loadOrganizations");
  },
  data() {
    return {
      selectedOrganization: null,
      oranization_search: "",
      person_search: "",
      ascending: false,
      currentSort: "name",
      ascendingA: false,
      currentSortA: "person_last_name",
      currentSortDir: "asc",
      currentSortDirA: "asc",
      selectAll: false,
      showOrganizationsTable: false,
      showFlashcard: false,
      showStaticIdCardList: false,
      selectedPersons: [],
      selectedDate: this.getDefaultDate(),
      includeExtraField: false,
      participantsKey: 0,
    };
  },
  computed: {
    idCardsByOrganization() {
      if (!this.selectedOrganization) return [];
      let idCards = this.$store.getters["idCard/getIdCards"].filter(
        (o) => o.organisation_id === this.selectedOrganization.id,
      );

      if (this.person_search) {
        idCards = idCards.filter((o) => {
          return (
            o.person_first_name
              .toLowerCase()
              .includes(this.person_search.toLowerCase()) ||
            o.person_last_name
              .toLowerCase()
              .includes(this.person_search.toLowerCase())
          );
        });
      }

      idCards = idCards.filter((o) => o.status === "active");

      return idCards.sort((a, b) => {
        let modifier = this.currentSortDirA === "desc" ? -1 : 1;
        if (a[this.currentSortA] < b[this.currentSortA]) return -1 * modifier;
        if (a[this.currentSortA] > b[this.currentSortA]) return 1 * modifier;
        return 0;
      });
    },

    organizations() {
      let org = this.$store.getters["organization/getOrganizations"];
      const user = this.$store.getters["auth/getUser"];
      if (!user.is_customer_admin && user.organisation_mappings) {
        org = org.filter((u) =>
          user.organisation_mappings.some(
            (o) => o.organisation_id === u.id && o.id_card_permission,
          ),
        );
      }

      if (this.oranization_search !== "") {
        org = org.filter((o) =>
          o.name.toLowerCase().includes(this.oranization_search.toLowerCase()),
        );
      }

      return org.sort((a, b) => {
        let modifier = this.currentSortDir === "desc" ? -1 : 1;
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
      });
    },

    organization() {
      return this.$store.getters["organization/getOrganization"];
    },
  },
  watch: {
    selectedOrganization() {
      this.selectAll = false;
    },
  },
  methods: {
    getDefaultDate() {
      const today = new Date();
      const defaultDate = new Date(today.setDate(today.getDate() + 7));
      return defaultDate.toISOString().slice(0, 10);
    },
    validateDate(date) {
      const selectedDate = new Date(date);
      const today = new Date();
      const twoWeeksLater = new Date(today.setDate(today.getDate() + 14));
      return selectedDate <= twoWeeksLater;
    },
    addIdCard(idCard) {
      if (this.isInSelectedIdCards(idCard)) {
        this.selectedPersons = this.selectedPersons.filter(
          (e) => e.id != idCard.id,
        );
      } else {
        this.selectedPersons.push(idCard);
      }
    },
    isInSelectedIdCards(idCard) {
      return this.selectedPersons.some((e) => e.id == idCard.id);
    },
    async generatePDF() {
      if (this.selectedPersons.length === 0) {
        this.$vs.notify({
          color: "danger",
          position: "bottom-right",
          title: "Es wurden keine Personen ausgewählt.",
        });
        return;
      }
      if (!this.selectedDate) {
        this.$vs.notify({
          color: "danger",
          position: "bottom-right",
          title: "Es wurde kein Datum ausgewählt.",
        });
        return;
      }
      if (!this.validateDate(this.selectedDate)) {
        this.$vs.notify({
          color: "danger",
          position: "bottom-right",
          title:
            "Das ausgewählte Datum darf nicht mehr als zwei Wochen in der Zukunft liegen.",
        });
        return;
      }
      const tempData = {
        id: this.selectedOrganization.id,
        list: this.selectedPersons.map((person) => person.person_id),
        dt: this.selectedDate,
        includeExtraField: this.includeExtraField,
      };
      try {
        await this.$store.dispatch(
          "organization/loadParticipantList",
          tempData,
        );
      } catch (error) {
        console.error("Fehler beim Laden der Teilnehmerliste:", error);
      }
    },
    async selectOrganization(organization) {
      this.selectedPersons = [];
      await this.$store.dispatch(
        "organization/loadOrganization",
        organization.id,
      );
      await this.$store.dispatch("idCard/loadIdCards", {
        organisation_id: organization.id,
      });
      this.selectedOrganization = this.organization;
    },
    isActiveOrganization(organizationId) {
      return (
        this.selectedOrganization &&
        organizationId === this.selectedOrganization.id
      );
    },
    selectAllItems() {
      this.idCardsByOrganization.forEach((idCard) => {
        idCard.selected = this.selectAll;
        if (!idCard.selected) {
          this.selectedPersons = this.selectedPersons.filter(
            (e) => e.id != idCard.id,
          );
        } else if (!this.isInSelectedIdCards(idCard)) {
          this.selectedPersons.push(idCard);
        }
      });
    },
    sortA(s) {
      if (s === this.currentSortA) {
        this.currentSortDirA = this.currentSortDirA === "asc" ? "desc" : "asc";
        this.ascendingA = !this.ascendingA;
      }
      this.currentSortA = s;
    },
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
        this.ascending = !this.ascending;
      }
      this.currentSort = s;
    },
  },
});
</script>

<style scoped>
.generate-pdf-button {
  position: relative;
  float: left;
  background-color: #007bff;
  color: #ffffff;
}
.cursor {
  cursor: pointer;
}
.active {
  background-color: #f0f0f0;
}
</style>
